import type { Feature, Polygon } from 'geojson';

const allNetherlandsFeature: Feature<Polygon> = {
  type: 'Feature',
  geometry: {
    type: 'Polygon',
    coordinates: [
      [
        [3.89198095187092, 51.19668963044225],
        [4.360594052027608, 51.32286754238686],
        [4.521537595268143, 51.4118835655368],
        [4.746319327778423, 51.4003579262143],
        [5.011412348181707, 51.38470634849702],
        [5.270425541035252, 51.23426635687693],
        [5.464949569568475, 51.24607261436401],
        [5.787149976641075, 51.14173330179372],
        [5.632132645959274, 50.84903878574028],
        [5.676423311868575, 50.75106344532904],
        [6.067657527398239, 50.732378181583016],
        [6.119329970958546, 50.942157717801564],
        [5.9938397508832395, 51.04437356663297],
        [6.23787442695442, 51.18026783447519],
        [6.1075911029069445, 51.2154399826991],
        [6.214421053287296, 51.23918614090623],
        [6.266965523988603, 51.52912474106853],
        [5.986457973231381, 51.826648259732906],
        [6.41460107701937, 51.81295941610395],
        [6.791071737246199, 51.881362051593385],
        [6.894416624366897, 51.95875941370525],
        [6.761544626639704, 52.04964436320731],
        [6.805835292549034, 52.108620644812646],
        [7.108488176260863, 52.226339544110374],
        [7.093724620957232, 52.415843432759885],
        [7.005143289139397, 52.483326807866234],
        [6.739399293685068, 52.483326807866234],
        [6.813217070200096, 52.635906555856764],
        [7.049433955048698, 52.62246497898121],
        [7.1088292815698395, 52.835911034045466],
        [7.254725172794707, 53.03552058506682],
        [7.195198028182396, 53.13390254976191],
        [7.234952427476301, 53.185176064571664],
        [7.194399824131779, 53.340365454648406],
        [7.024897830023377, 53.33680445008983],
        [6.987583854180457, 53.39767837513534],
        [6.874158730820824, 53.46673298603281],
        [6.578710064868943, 53.56384951888168],
        [5.632612069725781, 53.488667532118015],
        [4.7788988450465695, 53.37110846399273],
        [4.6344425168056205, 52.75628718102371],
        [4.346500860119278, 52.20960837348423],
        [3.910787887217907, 51.95315792974225],
        [3.392213720401628, 51.516524737941836],
        [3.299188040625495, 51.36142446862908],
        [3.4190725605421335, 51.219147918066625],
        [3.5683355003104964, 51.2546047843812],
        [3.75113181143152, 51.23503238692359],
        [3.7942303504964485, 51.207302401039726],
        [3.89198095187092, 51.19668963044225],
      ],
    ],
  },
  properties: {},
};

export default allNetherlandsFeature;
